export default [
  { id: 'date', label: 'Date' },
  { id: 'hdlChol', label: 'HDL Chol' },
  { id: 'ldlChol', label: 'LDL Chol' },
  { id: 'totalChol', label: 'Total Chol' },
  { id: 'triglycerides', label: 'Triglycerides' },
];
